module.exports = __webpack_public_path__ + "static/media/Logo.45a7a6a1.png";